import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "\n      h-100\n      w-100\n      d-flex\n      flex-column\n      justify-content-center\n      align-items-center\n      py-5\n    " }
const _hoisted_2 = { class: "mb-0 text-center" }
const _hoisted_3 = /*#__PURE__*/_createVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("p", _hoisted_2, [
      _createVNode("strong", null, _toDisplayString(_ctx.error.title), 1),
      _hoisted_3,
      _createTextVNode(_toDisplayString(_ctx.error.message), 1)
    ])
  ]))
}